type BuilderInput = {
  name: string;
  type: string;
  helperText?: string;
};

export type LoyaltyDiscountBadgeCopyInput = {
  anonymousDiscountTag?: string;
  loggedInPartialDiscountTag?: string;
};

export type LoyaltyRewardCopyInput = {
  anonymousRewardText?: string;
  anonymousCtaText?: string;
  loggedInNoDiscountRewardText?: string;
  loggedInNoDiscountCtaText?: string;
  loggedInPartialRewardText?: string;
  loggedInPartialRewardCtaText?: string;
};

export const LOYALTY_REWARD_COPY_AUTHORING_TOGGLE_NAME = "isLoyaltyRewardCopyAuthoringEnabled";

const BADGE_PLACEHOLDERS =
  'Available placeholders for logged-in users with eligible discount tiers only: {discount} = formatted discount in user currency (e.g. "EUR 15.00"), {discountPoints} = points required (e.g. "300"), {discountAmount} = raw discount number (e.g. "15").';

const REWARD_PLACEHOLDERS =
  'Available placeholders: {discount} = formatted discount in user currency (e.g. "EUR 15.00"), {discountPoints} = points required (e.g. "300"), {discountAmount} = raw discount number (e.g. "15"), {earnPoints} = points earned from purchase (e.g. "450").';

const LOYALTY_DISCOUNT_BADGE_COPY_SUB_FIELDS: BuilderInput[] = [
  {
    name: "anonymousDiscountTag",
    type: "string",
    helperText:
      "Text shown to non-logged-in users. Example: 'Log in to use your Ploom Club points for a discount'. Placeholders like {discount}/{discountPoints}/{discountAmount} are not available for anonymous state.",
  },
  {
    name: "loggedInPartialDiscountTag",
    type: "string",
    helperText:
      "Text shown to logged-in users with eligible discount tiers. Example: 'Additional {discount} OFF for {discountPoints} points'.",
  },
];

const LOYALTY_REWARD_COPY_SUB_FIELDS: BuilderInput[] = [
  {
    name: "anonymousRewardText",
    type: "string",
    helperText: "Reward text shown to non-logged-in users",
  },
  {
    name: "anonymousCtaText",
    type: "string",
    helperText: "CTA button text shown to non-logged-in users",
  },
  {
    name: "loggedInNoDiscountRewardText",
    type: "string",
    helperText: "Reward text shown to logged-in users with no eligible discount tiers",
  },
  {
    name: "loggedInNoDiscountCtaText",
    type: "string",
    helperText: "CTA button text shown to logged-in users with no eligible discount tiers",
  },
  {
    name: "loggedInPartialRewardText",
    type: "string",
    helperText:
      "Reward text shown to logged-in users with eligible discount tiers. Supports placeholders: {discount}, {discountPoints}, {discountAmount}.",
  },
  {
    name: "loggedInPartialRewardCtaText",
    type: "string",
    helperText: "CTA button text shown to logged-in users with eligible discount tiers",
  },
];

export const getLoyaltyDiscountBadgeCopyBuilderInput = () => ({
  name: "loyaltyDiscountBadgeCopy",
  type: "object",
  showIf: `options.get("hasLoyaltyDiscountBadge") === true`,
  defaultValue: {
    anonymousDiscountTag: "",
    loggedInPartialDiscountTag: "",
  },
  helperText: `Copy for the loyalty price badge only. ${BADGE_PLACEHOLDERS}`,
  subFields: LOYALTY_DISCOUNT_BADGE_COPY_SUB_FIELDS,
});

export const getLoyaltyRewardCopyAuthoringToggleBuilderInput = () => ({
  name: LOYALTY_REWARD_COPY_AUTHORING_TOGGLE_NAME,
  type: "boolean",
  defaultValue: false,
  friendlyName: "Enable loyalty reward copy authoring",
  helperText: "When disabled, ProductLoyaltyBlock uses legacy translation keys for reward text and CTA.",
});

export const getLoyaltyRewardCopyBuilderInput = () => ({
  name: "loyaltyRewardCopy",
  friendlyName: "Reward component configuration",
  type: "object",
  showIf: `options.get("${LOYALTY_REWARD_COPY_AUTHORING_TOGGLE_NAME}") === true`,
  defaultValue: {
    anonymousRewardText: "",
    anonymousCtaText: "",
    loggedInNoDiscountRewardText: "",
    loggedInNoDiscountCtaText: "",
    loggedInPartialRewardText: "",
    loggedInPartialRewardCtaText: "",
  },
  helperText: `Copy for the loyalty reward block. ${REWARD_PLACEHOLDERS}`,
  subFields: LOYALTY_REWARD_COPY_SUB_FIELDS,
});
